import styled from "styled-components";

export const PageContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 32px 24px 48px;
  box-sizing: border-box;
`;

export const ShareGrid = styled.div`
  width: min(1100px, 100%);
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 20px;
`;

export const ShareCard = styled.div`
  background: linear-gradient(180deg, #ffffff, #f7f8ff);
  border-radius: 20px;
  padding: 32px;
  box-shadow: 0 24px 40px rgba(15, 23, 42, 0.18);
  display: flex;
  flex-direction: column;
  gap: 16px;
  border: 1px solid #e0e4f2;
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 28px;
  color: #111;
`;

export const Subtitle = styled.p`
  margin: 0;
  color: #4a4a60;
  font-size: 15px;
  line-height: 1.4;
`;

export const LinkRow = styled.div`
  background: #f4f6ff;
  border-radius: 12px;
  border: 1px solid #e4e9ff;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const LinkInput = styled.input`
  border: none;
  background: transparent;
  flex: 1;
  font-weight: 600;
  color: #111;
  font-size: 16px;
  &:focus {
    outline: none;
  }
`;

export const ActionGroup = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`;

export const ActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 12px 18px;
  border-radius: 999px;
  border: none;
  font-weight: 600;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
  background: ${(props) => props.bg ?? "#ed4e2a"};
  box-shadow: 0 14px 30px rgba(15, 23, 42, 0.28);
  transition: transform 0.15s ease, box-shadow 0.2s ease, filter 0.2s ease;
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 18px 32px rgba(15, 23, 42, 0.32);
  }
`;

export const ActionIcon = styled.span`
  width: 36px;
  height: 36px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.22);
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const HintText = styled.p`
  margin: 0;
  color: #6b6b6b;
  font-size: 13px;
`;

export const InstructionList = styled.ul`
  margin: 4px 0 0;
  padding-left: 20px;
  color: #4b4b4b;
  font-size: 14px;
  line-height: 1.6;
`;

export const QRCodeCard = styled.div`
  background: linear-gradient(180deg, #fdfdfd, #f1f0ff);
  border-radius: 20px;
  border: 1px solid #e1e1ee;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  box-shadow: 0 20px 35px rgba(15, 23, 42, 0.15);
`;

export const QRCodeWrapper = styled.div`
  background: #fff;
  padding: 16px;
  border-radius: 24px;
  border: 1px solid rgba(0, 0, 0, 0.08);
`;

export const QRTitle = styled.span`
  font-weight: 600;
  color: #1a1a1a;
  font-size: 16px;
`;

export const ShareBadge = styled.span`
  align-self: flex-start;
  letter-spacing: 0.16em;
  font-size: 12px;
  font-weight: 700;
  color: #5d5de4;
  background: rgba(93, 93, 228, 0.1);
  padding: 6px 14px;
  border-radius: 999px;
`;

export const ShareHelper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
`;

export const HelperItem = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  border: 1px solid #e6e8f4;
  box-shadow: 0 8px 16px rgba(18, 20, 50, 0.06);
  font-size: 14px;
  color: #4b4b4b;
`;
